import React, { useEffect } from 'react';
import { Toast } from 'ratel-ui';
import { Router, Route } from 'react-router';
import { createBrowserHistory } from 'history';
import { ThemeProvider } from 'styled-components';
import lightTheme from './themes/light';
import 'ratel-ui/index.css';
import Contexts from './core/context';
import Zoing from './enemSimulation/containers/details';
import InitApm from './core/apm';

const history = createBrowserHistory();

export default function Root() {

  useEffect(() => {
    InitApm();
  }, []);

  return (
    <Contexts>
      <ThemeProvider theme={lightTheme}>
        <Router history={history}>
          <Route exact path="/:slug" component={Zoing}/>
        </Router>
        <Toast.box/>
      </ThemeProvider>
    </Contexts>
  );
}
